var _circle, _path, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ef4b3f",
    cx: 50,
    cy: 50,
    r: 41.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad352d",
    d: "M50,93.47c-23.97,0-43.47-19.5-43.47-43.47S26.03,6.53,50,6.53s43.47,19.5,43.47,43.47-19.5,43.47-43.47,43.47ZM50,9.53c-22.32,0-40.47,18.15-40.47,40.47s18.15,40.47,40.47,40.47,40.47-18.16,40.47-40.47S72.32,9.53,50,9.53Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#541b16",
    cx: 36.03,
    cy: 46.4,
    r: 6.69
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#541b16",
    cx: 63.97,
    cy: 46.4,
    r: 6.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#541b16",
    d: "M61.51,71.97c-.63,0-1.24-.31-1.6-.88-.14-.22-3.44-5.26-9.91-5.26s-9.89,5.23-9.93,5.28c-.57.87-1.74,1.12-2.62.55-.87-.57-1.12-1.74-.55-2.62.19-.29,4.66-7,13.1-7s12.94,6.74,13.12,7.03c.55.89.28,2.05-.6,2.61-.32.19-.66.29-1.01.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackPoor);
export default __webpack_public_path__ + "static/media/feedback-poor.6e3afa6c18f99f0fafe895fb5dd716f8.svg";
export { ForwardRef as ReactComponent };